import React, { useContext } from "react";
import { IngredientBase } from "./IngredientBase";
import IngredientRegisterModalView from "./ingredientRegister/IngredientRegisterModalView";
import { DrawingContext } from "../../../../components/drawing-tool/DrawingTool";
import { MappingSourceType } from "../../../../config/enums/MappingSourceType.enum";

const IngredientDetailsView = ({ modalData }:any) => {
      const {
        mappingSourceType,
      } = useContext(DrawingContext);
    const ingredientRegister = mappingSourceType === MappingSourceType.ingredient && !modalData.data.reference    
    const ingredientContentView = () =>{
        if (ingredientRegister){
            return <IngredientRegisterModalView />
        }
        return  <IngredientBase/>
    }

    return (
        <>{ingredientContentView()}</>     
    )
}

export default IngredientDetailsView